import { useState } from 'react';
import { useSiteData } from '@/contexts/SiteDataContext';
import type { Program } from '@/contexts/SiteDataContext';

export default function ProgramsSection() {
  const { data, updatePrograms } = useSiteData();
  const [programs, setPrograms] = useState<Program[]>([...data.programs]);
  const [saved, setSaved] = useState(false);

  const handleSave = () => { updatePrograms(programs); setSaved(true); setTimeout(() => setSaved(false), 2500); };
  const update = (i: number, field: keyof Program, val: string) => setPrograms(programs.map((p, idx) => idx === i ? { ...p, [field]: val } : p));
  const add = () => setPrograms([...programs, { name: 'New Program', desc: 'Description here', icon: 'ri-star-line', color: 'bg-primary-500' }]);
  const remove = (i: number) => setPrograms(programs.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-bold text-foreground-900 mb-1">Programs</h2>
          <p className="text-foreground-500 text-sm">Edit the "Our Programs" section shown on the homepage.</p>
        </div>
        <button onClick={add} className="inline-flex items-center gap-2 px-4 py-2.5 bg-secondary-500 text-white rounded-xl text-sm font-semibold hover:bg-secondary-600 transition-colors whitespace-nowrap">
          <i className="ri-add-line"></i> Add Program
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {programs.map((prog, i) => (
          <div key={i} className="border border-background-200 rounded-2xl p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className={`w-8 h-8 rounded-lg ${prog.color} flex items-center justify-center`}>
                  <i className={`${prog.icon} text-white text-sm`}></i>
                </div>
                <span className="text-sm font-bold text-foreground-800">{prog.name}</span>
              </div>
              <button onClick={() => remove(i)} className="w-7 h-7 flex items-center justify-center rounded-lg bg-rose-100 hover:bg-rose-200 text-rose-600 transition-colors cursor-pointer">
                <i className="ri-delete-bin-line text-xs"></i>
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="block text-xs text-foreground-500 mb-1">Program Name</label>
                <input type="text" value={prog.name} onChange={(e) => update(i, 'name', e.target.value)} className="w-full px-3 py-2 rounded-lg border border-background-200 text-sm bg-background-50 focus:outline-none focus:ring-1 focus:ring-primary-300" />
              </div>
              <div>
                <label className="block text-xs text-foreground-500 mb-1">Icon (Remix)</label>
                <input type="text" value={prog.icon} onChange={(e) => update(i, 'icon', e.target.value)} placeholder="ri-heart-line" className="w-full px-3 py-2 rounded-lg border border-background-200 text-sm bg-background-50 focus:outline-none focus:ring-1 focus:ring-primary-300" />
              </div>
              <div>
                <label className="block text-xs text-foreground-500 mb-1">Color class</label>
                <input type="text" value={prog.color} onChange={(e) => update(i, 'color', e.target.value)} placeholder="bg-primary-500" className="w-full px-3 py-2 rounded-lg border border-background-200 text-sm bg-background-50 focus:outline-none focus:ring-1 focus:ring-primary-300" />
              </div>
            </div>
            <div>
              <label className="block text-xs text-foreground-500 mb-1">Description</label>
              <textarea rows={2} value={prog.desc} onChange={(e) => update(i, 'desc', e.target.value)} className="w-full px-3 py-2 rounded-lg border border-background-200 text-sm bg-background-50 focus:outline-none focus:ring-1 focus:ring-primary-300 resize-none" />
            </div>
          </div>
        ))}
      </div>

      <button onClick={handleSave} className={`inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition-all duration-300 whitespace-nowrap ${saved ? 'bg-emerald-500 text-white' : 'bg-primary-500 text-white hover:bg-primary-600'}`}>
        <i className={saved ? 'ri-check-line' : 'ri-save-line'}></i>
        {saved ? 'Saved!' : 'Save Programs'}
      </button>
    </div>
  );
}